module.exports = __webpack_public_path__ + "img/footer.90d6b5a3.png";